var UOC = /** @class */ (function () {
    function UOC() {
        this.id = null;
        this.name = '';
    }
    return UOC;
}());
export { UOC };
